/**
 * The name of a tool call as the Tools Used panel and the tool timeline show
 * it. Every path now sends `name` (BUG-1.5.0_7); a session saved before that
 * fix carries the recipe executor's `tool` key in its metadata_json, which the
 * history reloads verbatim — those rows are named from it instead of staying
 * blank.
 */
export const toolCallName = (call: { name?: string; tool?: string } | null | undefined): string =>
  call?.name ?? call?.tool ?? '';
